import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'El Método',
    href: '#metodo'
  }, {
    name: 'Qué Incluye',
    href: '#incluye'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-219">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-220">
        <a href="#" className="font-serif text-2xl font-semibold text-burgundy tracking-wide" data-id="element-221">
          Bienvenda
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-222">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-taupe hover:text-rosegold transition-colors" data-id="element-223">
              {link.name}
            </a>)}
          <a href="#pricing" className="bg-rosegold text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-rosegold/90 transition-colors shadow-sm" data-id="element-224">
            Quiero Acceder
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-burgundy" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-225">
          {mobileMenuOpen ? <X size={24} data-id="element-226" /> : <Menu size={24} data-id="element-227" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-cream py-4 px-6 flex flex-col space-y-4" data-id="element-228">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-base font-medium text-taupe hover:text-rosegold transition-colors" data-id="element-229">
              {link.name}
            </a>)}
          <a href="#pricing" onClick={() => setMobileMenuOpen(false)} className="bg-rosegold text-white px-6 py-3 rounded-full text-center font-medium hover:bg-rosegold/90 transition-colors" data-id="element-230">
            Quiero Acceder
          </a>
        </div>}
    </header>;
}